import mapParcelOrg from 'dataMappers/parcelOrg.dataMapper';
import Shipment from 'interfaces/PmParcel';
import APIError from 'exceptions/APIError';
import AppError from 'exceptions/AppError';
import { postValidateConsumer } from '../fetchers';

export const validateConsumer = async (
  orgId: number,
  slug: string,
  shipmentPk: number,
  searchTerms: { [key: string]: string | number },
): Promise<{ token: string; shipment: Shipment }> => {
  try {
    const {
      data: { token, shipment: resShipment },
    } = await postValidateConsumer(orgId, slug, shipmentPk, searchTerms);
    const shipment = mapParcelOrg(resShipment);
    return { token, shipment };
  } catch (error) {
    if (error instanceof APIError) {
      throw new AppError(error.message);
    }
    throw error;
  }
};
